export default __webpack_public_path__ + "6900b30bfcbceb55a21d26ac4f90b159.svg";